import {
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonSpinner,
  IonCard,
  IonFooter,
  IonButtons,
  IonToolbar,
} from "@ionic/react";
import {useMemo, useRef, useState} from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Location } from "../../../@types/location";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { createOrganization } from "../../../store/organizations/actions/createOrganization";

export const CreateForm: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const formSubmit = useRef<any>(null);
  const [createStatus, setCreateStatus] = useState<string>();

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const onSubmit = async (data: Location) => {
    try {
      setCreateStatus("pending");
      const { payload: created }: any = await dispatch(createOrganization(data));
      if (created) {
        setCreateStatus("fulfilled");
        history.replace(`/app/gerencia/mis-clientes/detalle/${created.id}`);
      }
    } catch (error) {
      setCreateStatus("rejected");
    }
  };

  const controllers = useMemo(()=>{
    return [({ field: { onChange, value } }:any) => (
      <IonInput
        placeholder="Ej. Mi Cliente"
        value={value}
        onIonChange={({ detail: { value } }) => onChange(value)}
        {...register("name", {
          required: "Campo obligatorio.",
        })}
      />
    )]
  },[])

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <IonCard style={{ maxWidth: 700 }}>
        <br />
        <IonItem lines="inset">
          <IonLabel position="stacked">Nombre</IonLabel>
          <Controller
            name="name"
            control={control}
            render={controllers[0]}
          />
        </IonItem>
        {errors.name && (
          <IonItem lines="none">
            <InputErrorMessage errorMessage={errors.name?.message || ""} />
          </IonItem>
        )}

        <br />
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton
                ref={formSubmit}
                fill="solid"
                type="submit"
                disabled={createStatus === "pending"}
              >
                {createStatus === "pending" ? (
                  <>
                    <IonSpinner />
                    <span className="ion-margin-left">Creando cliente</span>
                  </>
                ) : (
                  <>Crear cliente</>
                )}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonCard>
    </form>
  );
};
